/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { CompanyDescriptionControllerService } from './services/company-description-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    CompanyDescriptionControllerService,
    ApiConfiguration
  ],
})
export class CustomersCompanydescriptionModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersCompanydescriptionModule> {
    return {
      ngModule: CustomersCompanydescriptionModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersCompanydescriptionModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersCompanydescriptionModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
